import React from 'react'
import { Tag } from 'antd'
import translate from 'utils/translate'
import { IStep } from 'egi/types'
import { colors } from 'styles/colors'
import ProposalEgiModel from 'egi/models/ProposalEgiModel'
import { ExpirationDateTag } from '../ExpirationDateTag/ExpirationDateTag'

const cndTagColor = {
  APPROVED: colors.approved,
  REPROVED: colors.reproved,
  IN_ATTENTION: colors.remaking,
  CERTIFICATE_GENERATION_INFO: colors.remaking,
  NO_DATA_FOUND_INFO: colors.reproved
}

function isPartnerCndApiError (step: IStep): boolean {
  if (step?.cnd?.requestStatus === 'ERROR') return true
  return false
}

function hasCndInAttention (step: IStep): boolean {
  if (step?.cnd?.requestAnalysisStatus === 'IN_ATTENTION') return true

  const result = step?.cnd?.result
  if (result) {
    const rootAnalysis = String(result.analysis_status || '').toUpperCase()
    if (rootAnalysis === 'IN_ATTENTION') return true
    const serviceAnalysis = String(result.service_infos?.[0]?.analysis_status || '').toUpperCase()
    if (serviceAnalysis === 'IN_ATTENTION') return true
  }

  return false
}

function CndTagStatus ({ step }: { step: IStep }) {
  const hasCallbackData = Boolean(step?.cnd?.result)
  const hasRequestedCnd = Boolean(step?.cnd?.requestId)
  const partnerApiError = isPartnerCndApiError(step)
  const hasInAttentionMsg = hasCndInAttention(step)

  const hasNoDataFoundInfo =
    step?.cnd?.requestAnalysisStatus === 'NO_DATA_FOUND_INFO' ||
    Boolean(step?.cnd?.msg_infos?.some((info) => {
      const status = String(info?.status || '').toLowerCase()
      const message = String(info?.msg || '').toLowerCase()

      return status.includes('no_data_found_info') || message.includes('nao foram encontradas informacoes')
    }))

  if (partnerApiError) {
    return (
      <Tag
        className="mt-1 ml-1"
        color={colors.reproved}
      >
        API Indisponível
      </Tag>
    )
  }

  if (step?.automaticCNDStatus) {
    return (
      <Tag
        className="cnd-tag"
        color={colors.canceled}
      >
        {step?.automaticCNDStatus}
      </Tag>
    )
  }

  if (hasRequestedCnd) {
    if (hasCallbackData && hasInAttentionMsg) {
      return (
        <Tag
          className="mt-1 ml-1"
          color={colors.remaking}
          title="Verificar status em Certidões"
        >
          Atenção
        </Tag>
      )
    }

    return (
      <>
        <Tag
          className="mt-1 ml-1"
          color={hasCallbackData ? '#24B0FF' : '#FFC107'}
        >
          {hasCallbackData ? 'Processado' : 'Em Processamento'}
        </Tag>

        {hasCallbackData && hasNoDataFoundInfo && (
          <Tag
            className="mt-1 ml-1"
            color={colors.remaking}
            title="Verificar status em Certidões"
          >
            Atenção
          </Tag>
        )}
      </>
    )
  }

  if (step.cnd && step.cnd.requestAnalysisStatus) {
    return (
      <Tag
        className="mt-1 ml-1"
        color={cndTagColor[step.cnd.requestAnalysisStatus]}
      >
        {translate.cndTagStatus(step.cnd.requestAnalysisStatus)}
      </Tag>
    )
  }

  return null
}

function convertToAmericanPattern (dateString: string | null): string | null {
  if (!dateString) return null

  const parts = dateString.split('/')

  if (parts.length === 3) {
    const day = parts[0]
    const month = parts[1]
    const year = parts[2]

    // Rearrange in American pattern (month/day/year)
    return `${month}/${day}/${year}`
  } else {
    return null // Return null for invalid date format
  }
}

export function CndTagExpirationDate ({
  step
}: { step: IStep }) {
  const expirationDate = ProposalEgiModel.getCndExpirationDateFromObject(step?.form)
  const expirationDateAutomatic = convertToAmericanPattern(ProposalEgiModel.getCurrentCndExpirationDate(step?.cnd))

  return (
    <ExpirationDateTag
      expirationDate={expirationDate || expirationDateAutomatic}
    />
  )
}

export default CndTagStatus
